import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import axiosInstance from "../../utils/services/api";
import { toast } from "react-toastify";
import { emailRegex } from "utils/constants";

const ForgotPassword = () => {
  const initialValues = { email: "" };

  const validationSchema = Yup.object({
    email: Yup.string()
      .matches(emailRegex, "Invalid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosInstance.post(
        "/auth/forgot-password",
        values
      );

      const message =
        response.status === 204
          ? "Password reset link sent successfully!"
          : response?.data?.message;

      toast.success(message);
      resetForm();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred. Please try again later.";
      toast.error(errorMessage);
    }
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2">
      <div className="mt-[10vh] w-full max-w-[500px] flex-col items-center md:pl-4">
        <div className="rounded-xl bg-white p-6 shadow-lg dark:bg-navy-900">
          <h4 className="mb-2.5 text-center text-4xl font-bold text-navy-700">
            Forgot Password?
          </h4>
          <p className="mb-9 text-center text-base font-normal text-gray-600">
            Lost your password? Enter your email to reset it securely.
          </p>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form>
              {/* Email Field */}
              <div className="mb-3">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email Address <span className="text-red-700">*</span>
                </label>
                <Field
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your Email"
                  className="mt-1 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none focus:border-gray-700 dark:border-white/10 dark:text-white"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="mt-1 text-sm text-red-500"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="mb-3 mt-2 w-full rounded-xl bg-blueSecondary py-3 text-base font-medium text-white transition duration-200 active:bg-[#14AADD] dark:bg-brand-400 dark:hover:bg-brand-300"
              >
                Submit
              </button>

              {/* Back to Login */}
              <div className="text-center">
                <Link
                  to="/auth/log-in"
                  className="text-sm font-medium text-[#06A7E0]"
                >
                  Back to log in ➔
                </Link>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;